import { useSuspenseQuery } from '@apollo/client/react';
import { ClockIcon } from 'lucide-react';

import { AppsDocument } from 'src/graphql/actions/apps/apps.query';
import { withSuspense } from 'src/hoc';

import { InfoCard, InfoCardSkeleton } from '../../ui';

const FinishProtectingCardSkeleton = () => <InfoCardSkeleton statsCount={2} />;

const FinishProtectingCard = () => {
  const {
    data: { apps: inProgressApps },
  } = useSuspenseQuery(AppsDocument, {
    fetchPolicy: 'cache-and-network',
    variables: { needsFinishing: true, perPage: 0 },
  });
  const {
    data: { apps: unprotectedApps },
  } = useSuspenseQuery(AppsDocument, {
    fetchPolicy: 'cache-and-network',
    variables: { productsExist: false, perPage: 0 },
  });

  const stats = [
    { label: 'Protection in progress', value: inProgressApps.nodesCount },
    { label: 'Without protection', value: unprotectedApps.nodesCount },
  ];

  return (
    <InfoCard
      icon={ClockIcon}
      title="Finish protecting"
      totalCount={inProgressApps.nodesCount + unprotectedApps.nodesCount}
      stats={stats}
    />
  );
};

export default withSuspense(FinishProtectingCard, FinishProtectingCardSkeleton);
